import { render, staticRenderFns } from "./GenericProductPopup.vue?vue&type=template&id=1b0c3407"
import script from "./GenericProductPopup.vue?vue&type=script&lang=js"
export * from "./GenericProductPopup.vue?vue&type=script&lang=js"
import style0 from "./GenericProductPopup.vue?vue&type=style&index=0&id=1b0c3407&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports